import { FC } from 'react';
import EditIcon from '@/assets/edit.svg';
import { InfoTable } from '@/components/info-table';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { DrawerContentLayout } from '@/layouts/drawer-content-layout';
import { Organisation } from '@/types/organisation';

export type ViewOrganisationProps = {
  organisation: Organisation;
  onDisable: () => void;
  onEdit: () => void;
};

export const ViewOrganisation: FC<ViewOrganisationProps> = ({
  organisation,
  onDisable,
  onEdit,
}) => (
  <DrawerContentLayout
    buttonItems={[
      <Button key="disable" onClick={onDisable} variant="secondary-warning">
        {strings.organisations.drawer_edit_form.disable}
      </Button>,
      <div className="flex-grow" key="flex"></div>,
      <Button key="edit" onClick={onEdit} variant="primary">
        <EditIcon />
        {strings.organisations.drawer_view.edit}
      </Button>,
    ]}
    mainContent={
      <InfoTable
        rows={[{ label: 'Organisation name', value: organisation.name }]}
        title="Organisation Information"
      />
    }
  />
);
